<div class="modal-overlay" *ngIf="visible">
   <div class="modal-container">
      <ng-content></ng-content>
      <p-button class="close-btn" size="small" icon="pi pi-times" text="true" (click)="close()"></p-button>
   </div>
</div>
